import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import CarouselForm from './CarouselForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class NewCarouselModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }
    submitHandler = ( { carousel } ) => {
        this.setState( { fetching: true } );

        this.props.createCarousel( { ...carousel } )
        .then( ( newCarousel ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newCarousel );
        } );
    }
    render() {
        const initialValues = {
            context_order: 0,
            published: false,
            context: 'home_page',
            ui_type: 'small_card_carousel',
        };
        return (
            <DLModal title='New Carousel'
            closeHandler={ this.props.closeModal }>
                <div>
                    <CarouselForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        createCarousel: ( data ) => {
            return dAPI.post( '/admin/curated-carousels', data );
        },
        updateCarousel: ( id, data ) => {
            return dAPI.patch( `/admin/curated-carousels/${ id }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( NewCarouselModal );
